module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "l-footer"
  }, [_c('div', {
    staticClass: "l-footer__primary"
  }, [_c('nav', {
    staticClass: "footer-link-list"
  }, [_c('h1', {
    staticClass: "footer-link-list-heading"
  }, [_vm._v("Contact")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/contact-us"
    }
  }, [_vm._v("Customer Service")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/contact-us"
    }
  }, [_vm._v("Sales Representatives")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/contact-us"
    }
  }, [_vm._v("Showrooms")])]), _vm._v(" "), _c('nav', {
    staticClass: "footer-link-list"
  }, [_c('h1', {
    staticClass: "footer-link-list-heading"
  }, [_vm._v("Downloads")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/downloads#About-Leather"
    }
  }, [_vm._v("About Leather")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/downloads#Environmental"
    }
  }, [_vm._v("Environmental")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/downloads#Catalogs"
    }
  }, [_vm._v("Catalogs")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/downloads#Product-Cut-Sheets"
    }
  }, [_vm._v("Product Cut Sheets")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/downloads#Installation"
    }
  }, [_vm._v("Installation")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/downloads#Maintenance"
    }
  }, [_vm._v("Maintenance")])]), _vm._v(" "), _c('nav', {
    staticClass: "footer-link-list"
  }, [_c('h1', {
    staticClass: "footer-link-list-heading"
  }, [_vm._v("Product")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/upholstery-leather/categories/"
    }
  }, [_vm._v("Upholstery Leather")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/architectural-products/"
    }
  }, [_vm._v("Architectural Products")])]), _vm._v(" "), _c('nav', {
    staticClass: "footer-link-list"
  }, [_c('h1', {
    staticClass: "footer-link-list-heading"
  }, [_vm._v("About")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/about-us"
    }
  }, [_vm._v("About Us")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/about-leather"
    }
  }, [_vm._v("About Leather")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/about-cork"
    }
  }, [_vm._v("About Cork")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/about-how-leather-is-made"
    }
  }, [_vm._v("How Leather is Made")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/about-glossary"
    }
  }, [_vm._v("Glossary")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/about-Environmental"
    }
  }, [_vm._v("Environmental")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/about-Custom"
    }
  }, [_vm._v("About Custom")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/Collaborators"
    }
  }, [_vm._v("Collaborators")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/news"
    }
  }, [_vm._v("News")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/Press"
    }
  }, [_vm._v("Press")])]), _vm._v(" "), _c('nav', {
    staticClass: "footer-link-list"
  }, [_c('h1', {
    staticClass: "footer-link-list-heading"
  }, [_vm._v("Policies")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/faq"
    }
  }, [_vm._v("FAQs")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/privacy-policy"
    }
  }, [_vm._v("Privacy Policy")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/selling-policy"
    }
  }, [_vm._v("Selling Policy")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/terms-of-use"
    }
  }, [_vm._v("Terms Of Use")])])]), _vm._v(" "), _c('div', {
    staticClass: "l-footer__secondary"
  }, [_c('form', {
    staticClass: "mailing-list-form validate",
    attrs: {
      "action": "https://filzfelt.us6.list-manage.com/subscribe/post?u=b7c765aef80b20793da90832f&id=0a5d45439f",
      "method": "post",
      "id": "mc-embedded-subscribe-form",
      "name": "mc-embedded-subscribe-form",
      "target": "_blank",
      "novalidate": ""
    }
  }, [_c('input', {
    staticClass: "input-text mailing-list-form__input required email",
    attrs: {
      "type": "email",
      "value": "",
      "name": "EMAIL",
      "id": "mce-EMAIL",
      "placeholder": "Enter your email address..."
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "mailing-list-form__submit button",
    attrs: {
      "type": "submit",
      "value": "Sign Up",
      "name": "subscribe",
      "id": "mc-embedded-subscribe"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "social-links"
  }, [_c('h2', {
    staticClass: "social-links__heading"
  }, [_vm._v("Follow Us")]), _vm._v(" "), _c('a', {
    staticClass: "social-links__link social-links__link--facebook",
    attrs: {
      "href": "https://www.facebook.com/spinneybeck",
      "target": "_blank"
    }
  }, [_vm._v("Facebook")]), _vm._v(" "), _c('a', {
    staticClass: "social-links__link social-links__link--instagram",
    attrs: {
      "href": "https://instagram.com/spinneybeck",
      "target": "_blank"
    }
  }, [_vm._v("Instagram")]), _vm._v(" "), _c('a', {
    staticClass: "social-links__link social-links__link--vimeo",
    attrs: {
      "href": "https://vimeo.com/spinneybeck",
      "target": "_blank"
    }
  }, [_vm._v("Vimeo")])]), _vm._v(" "), _c('div', {
    staticClass: "social-links"
  }, [_c('h2', {
    staticClass: "social-links__heading"
  }, [_vm._v("LOOKING FOR FELT?")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "//www.spinneybeck.com/images/pages/footer/ff-logo.png"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "contact-info"
  }, [_c('div', {
    staticClass: "vcard"
  }, [_c('div', {
    staticClass: "tel"
  }, [_vm._v("800.482.7777")]), _vm._v(" "), _c('div', {
    staticClass: "tel"
  }, [_vm._v("+1.716.446.2380")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('a', {
    attrs: {
      "href": "mailto:sales@spinneybeck.com"
    }
  }, [_vm._v("sales@spinneybeck.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "contact-info__copyright"
  }, [_vm._v("©2017 Spinneybeck. All Rights Reserved.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23863119"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/pages/wrappers/FooterSpinneybeck.vue
// module id = 564
// module chunks = 1